<template>
  <nav class="breadcrumb container" :aria-label="label">
    <ol>
      <li v-for="(item, index) in items" :key="index">
        <router-link v-if="item.to" :to="to(item.to)">{{ item.label }}</router-link>
        <span v-else aria-current="page">{{ item.label }}</span>
      </li>
    </ol>
  </nav>
</template>

<script setup>
import { computed } from 'vue'
import { useLocale } from '../composables/useLocale'

defineProps({
  // [{ label, to? }] — the last item has no link.
  items: { type: Array, required: true }
})

const { isAr, to } = useLocale()
const label = computed(() => (isAr.value ? 'مسار التنقل' : 'Breadcrumb'))
</script>

<style scoped>
.breadcrumb {
  padding-top: 28px;
}

ol {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: var(--tertiary);
}

li + li::before {
  content: '/';
  margin-inline-end: 8px;
  color: var(--placeholder);
}

a {
  color: var(--tertiary);
}

a:hover {
  color: var(--ink);
}

[aria-current] {
  color: var(--ink);
}
</style>
